import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/lib/guards';

/**
 * Layout route for /clients/:clientId/*. Renders <Outlet /> so child routes
 * (`/` index = detail screen, `/edit` = edit form) can mount here. If this
 * returned the detail screen directly, the edit child would silently fail
 * to render — same fix Module 1 had to apply to practitioner detail.
 */
export const Route = createFileRoute('/_staff/admin/workspace/clients/$clientId')({
  beforeLoad: () => {
    requirePermission('client:read');
  },
  component: WorkspaceClientLayout,
  staticData: { crumb: 'Client' },
});

function WorkspaceClientLayout() {
  return <Outlet />;
}
